



















































import {
    Component, Emit, Model, Prop, Vue, Watch,
} from 'vue-property-decorator';
import { DELETE_PHOTO } from '../../../store/modules/template';
import RoundCheck from '@/components/global/input/RoundCheck.vue';
import { findIndex } from 'lodash';
import { upload } from '@/plugins/papybase/papybaseInit';

@Component({
    components: {
        RoundCheck,
    },
})
export default class InsertPhotoDialogPhotosItem extends Vue {
    @Prop({ default: '' }) readonly src!: string;
    @Prop({ default: '' }) readonly hash!: string;
    @Prop() readonly dialogStatus!: string;
    @Prop({ default: [] }) readonly checkedList!: string[];

    public checked = false;

    public isHover = false;

    public showDeleteButton = false;

    public onDeleteButtonClick() {
        upload.deleteImageByID(this.jwt, this.hash).then((res) => {
            if (res) {
                this.$store.commit(DELETE_PHOTO, this.hash);
            }
        }).catch((err) => {
            console.error(err);
        });
    }

    @Watch('checked')
    private onCheckedChanged(val: boolean, oldVal: boolean) {
        if (val) {
            this.$emit('checked', this.src);
        } else {
            this.$emit('unchecked', this.src);
        }
    }

    @Watch('dialogStatus')
    private onCheckDialogChanged(val: boolean, oldVal: boolean) {
        if (!val) {
            this.checked = false;
        }
    }

    @Watch('checkedList', { immediate: true })
    private onCheckedListChanged(val: boolean, oldVal: boolean) {
        if (!this.$store.getters.isMultipleImage && this.checkedList.length > 0) {
            const theIndex = findIndex(this.checkedList, item => item === this.src);
            if (theIndex !== -1) {
                this.checked = true;
            } else {
                this.checked = false;
            }
        }
    }

    get jwt() {
        return this.$store.getters.getJwt;
    }

    get showRoundCheck() {
        return this.checked || this.isHover;
    }

    get showOpacity() {
        return !this.checked && this.isHover;
    }
}
